const NextI18Next = require('next-i18next');
module.exports = NextI18Next;
